import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ApiHelper from "../../api/api_helper";
import LoadingIndicator from "../loading/LoadingIndicator";
import GateoutDetailView from "./GateoutDetailView";
import { useDialog } from "../../context/dialog_context";

const GateoutDetailController = () => {
  const { id } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [surveyForm, setSurveyForm] = useState(null);
  const [, setApiError] = useState(null);

  const navigate = useNavigate();

  const { showDialog } = useDialog();

  useEffect(() => {
    getSurveyFormDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getSurveyFormDetail = async () => {
    try {
      setIsLoading(true);
      const response = await ApiHelper.get(`/survey/${id}`);
      if (response.status !== 200) {
        throw response;
      }
      setSurveyForm(response.data.data);
    } catch (error) {
      setApiError(error.data);
    } finally {
      setIsLoading(false);
    }
  };

  const approveButton = async () => {
    try {
      setIsLoading(true);
      let updateSurveyData = surveyForm;
      updateSurveyData.updateFrom = "approveGateOut";
      updateSurveyData.gateStatus = "out";
      const response = await ApiHelper.put(
        `survey/${id}/change`,
        updateSurveyData
      );

      if (response.status !== 200) {
        throw response;
      }
      showDialog("อัพเดทข้อมูลสำเร็จแล้ว", "");
      navigate(-1);
    } catch (error) {
      showDialog("เกิดข้อผิดพลาด", error.message);
      setApiError(error.data);
    } finally {
      setIsLoading(false);
    }
  };

  const notApproveButton = async () => {
    try {
      setIsLoading(true);
      let updateSurveyData = surveyForm;
      updateSurveyData.gateStatus = "in";
      updateSurveyData.requestGateOutDate = null;
      const response = await ApiHelper.put(
        `survey/${id}/change`,
        updateSurveyData
      );

      if (response.status !== 200) {
        throw response;
      }
      showDialog("อัพเดทข้อมูลสำเร็จแล้ว", "");
      navigate(-1);
    } catch (error) {
      showDialog("เกิดข้อผิดพลาด", error.message);
      setApiError(error.data);
    } finally {
      setIsLoading(false);
    }
  };

  const previousPage = () => {
    navigate(-1);
  };

  if (isLoading) {
    return <LoadingIndicator />;
  }

  return (
    <GateoutDetailView
      surveyForm={surveyForm}
      approveButton={approveButton}
      notApproveButton={notApproveButton}
      previousPage={previousPage}
    />
  );
};

export default GateoutDetailController;
